export default "__VITE_ASSET__D3b2l0Sn__"